<template>
	<div class="job-assignation-factor tw-flex">
		<div class="tw-flex job-assignation-factor-info tw-items-center">
			<img :src="factor.urlImage" alt="" class="job-assignation-factor-img" />
			<div class="text-info job-assignation-factor-name tw-flex-auto tw-flex tw-items-center">
				{{ factor.name }}
			</div>
		</div>
		<div class="tw-flex-auto job-assignation-factor-degrees">
			<job-factor-degrees-selection
				:degrees="factor.degrees"
				:selected-degree="factor.selectedDegree"
				@degreeSelected="onDegreeSelected"
			/>
		</div>
	</div>
</template>

<script>
import JobFactorDegreesSelection
	from '@/modules/polls/components/custom/JobEvaluationPollPage/JobFactorDegreesSelection';

export default {
	name: 'JobFactorAssignationFactor',
	components: { JobFactorDegreesSelection },
	props: ['factor', 'index'],
	methods: {
		onDegreeSelected(degree) {
			this.$emit('factorChange', {
				factor: {
					...this.factor,
					selectedDegree: degree,
				},
				index: this.index,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.job-assignation-factor {
	border-radius: 8px;
	border: solid 1px #cdcdcd;
	.job-assignation-factor-info {
		padding: 15px;
		max-width: 220px;
		min-width: 220px;
		.job-assignation-factor-img {
			width: 30px;
			min-width: 30px;
			height: 30px;
			margin-right: 15px;
		}
		.job-assignation-factor-name {
			border-left: 1.5px solid var(--app-color-secondary);
			padding: 5px 5px 5px 15px;
			line-height: 16px;
			min-height: 40px;
		}
	}
	.job-assignation-factor-degrees {
		border-left: 1px solid #cdcdcd;
		padding: 15px;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/polls/components/custom/JobEvaluationPollPage/JobFactorAssignationFactor.vue